import request from '@/utils/request'

const getCategoryById = (id) => {
  return request({
    url: `${process.env.VUE_APP_BOYUAN_API}/exam-category/${id}`,
    method: 'get'
  })
}

const getCategoryTreeList = (query) => {
  return request({
    url: `${process.env.VUE_APP_BOYUAN_API}/exam-category/tree-list`,
    method: 'get',
    params: query
  })
}

const getCategoryPageList = (query) => {
  return request({
    url: `${process.env.VUE_APP_BOYUAN_API}/exam-category/page-list`,
    method: 'get',
    params: query
  })
}

function createCategory(data) {
  return request({
    url: `${process.env.VUE_APP_BOYUAN_API}/exam-category`,
    method: 'post',
    data
  })
}

const updateCategory = (id, data) => {
  return request({
    url: `${process.env.VUE_APP_BOYUAN_API}/exam-category/${id}`,
    method: 'put',
    data
  })
}

const getCategoryList = (parentId) => {
  return request({
    url: `${process.env.VUE_APP_BOYUAN_API}/exam-category`,
    method: 'get',
    params: { parentId }
  })
}

// const updateCategoryState = (id, state) => {
//   return request({
//     url: `${process.env.VUE_APP_BOYUAN_API}/exam-category/${id}/state`,
//     method: 'put',
//     params: { state }
//   })
// }

export default {
  createCategory,
  updateCategory,
  getCategoryById,
  getCategoryTreeList,
  getCategoryPageList,
  getCategoryList
  // updateCategoryState
}
